import React, { useContext, useState } from 'react';
//import { useNavigate } from "react-router-dom";
import { Box, Button, Header, Text, Menu, Nav, ResponsiveContext, Tip } from 'grommet';
import { Hpe as HpeIcon, Slack as SlackIcon, Menu as MenuIcon } from 'grommet-icons';
//import { UserContext } from '../helpers';

function goNav(url) {
  window.location.href = url;
}

const items = [
  { label: 'Home', 
    onClick: () => { goNav('/') } ,
    tooltip: 'Status Central home...',
    id: 'home'  
  },   
  { label: 'IT Support', 
    onClick: () => { goNav('https://myitsupport.ext.hpe.com/ITSHome') } ,
    tooltip: 'myITsupport site...',
    id: 'issue'  
  },    
  { 
    icon: (<SlackIcon color="plain" size="large" />),
    onClick: () => { goNav('slack://channel?team=E01LD9FH0JZ&id=C02N0QT284A') } ,
    tooltip: 'myITsupport Slack channel...',
    id: 'slack' 
  },
];

const AppHeader = () => {

  //const navigate = useNavigate();
  const size = useContext(ResponsiveContext);
 
  const [focused] = useState(false);
  //const [focused, setFocused] = useState(false);

  return (

    <Header fill="horizontal" pad={{ horizontal: 'medium' }} background="background-front">
      <Tip content="Status Central home...">
        <Button onClick={() => { goNav("/"); }}>
          <Box direction="row" align="start" gap="medium" pad={{ vertical: 'small' }} responsive={false}>
            <Box height="24px" justify="center">
              <HpeIcon color="brand"/>
            </Box>
            {(!['xsmall', 'small'].includes(size) ||
              (['xsmall', 'small'].includes(size) && !focused)) && (
              <Box direction="row" gap="xsmall">
                <Text color="text-strong" weight="bold">HPE</Text>
                <Text color="text-strong">Status Central Home</Text>
              </Box>
            )}
          </Box>
        </Button>
      </Tip>
      {!['xsmall', 'small'].includes(size) ? (
        <Nav direction="row" gap="small">
          {items.map(item => (
            <Tip content={item.tooltip}>
              <Button label={item.label}
                      icon={item.icon}
                      key={item.label} 
                      onClick={item.onClick}/>
            </Tip>  
        ))}

        </Nav>

      ) : (

        <Menu icon={<MenuIcon/>} items={items} /> 

      )}
    </Header>
  );
};

export { AppHeader as Header };
